import {memo} from "react";
import {Controller, useFormContext, Validate} from "react-hook-form";
import {ClientReportSubmitCommentInput, ClientReportSubmitInput} from "../domain";

type CommentsInputProps = {
    sending: boolean;
    required?: boolean | undefined;
    fieldName?: keyof ClientReportSubmitCommentInput | undefined;
    label?: string | undefined;
    validate?: Validate<string> | undefined;
};

const max2048 = (v: string) => {
    return (v || '').length <= 2048 || 'Maximum length is 2048 characters';
};

export const CommentsInput = memo((
    {
        sending,
        required = false,
        validate,
        fieldName = 'comments',
        label = 'Comments'
    }: CommentsInputProps
) => {

    const {
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();
    let errorCss = "";
    if (errors[fieldName]) {
        errorCss = "border-red-500";
    }

    return (
        <li className="w-full flex text-base items-center py-2 text-black">
            <div className="w-2/6 text-right">
                {label}
            </div>
            <div className="w-3/6">
                <Controller
                    name={fieldName}
                    control={control}
                    rules={{
                        required: {
                            value: required,
                            message: 'Required'
                        },
                        validate: {
                            max2048,
                            ...(validate != null ? {custom: validate} : {})
                        }
                    }}
                    render={({field: {onChange, onBlur, value}}) =>
                        <textarea
                            onChange={onChange}
                            onBlur={onBlur}
                            disabled={sending}
                            value={value}
                            className={`w-full ml-4 border block appearance-none text-black bg-white border-gray-400 leading-tight focus:outline-none p-1 rounded ${errorCss}`}
                            rows={3}
                        />
                    }
                />

                {
                    errors[fieldName] &&
                    <div className="pl-4 text-red-700">
                        {errors[fieldName]?.message}
                    </div>
                }
            </div>
        </li>
    );
});
